/**
 * @description 底部备案
 */

import {defineComponent} from 'san';
import {ICP_CONF} from '../../../../common/const/index';
import styles from './index.module.less';
import {footerProps} from './interface';

const Footer = defineComponent<footerProps>({
    template: /* html */ `
        <div class="${styles['footer-wrap']}">
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code={{networkSecurityCode}}" target="_blank">京公网安备{{networkSecurityCode}}号</a>
            <a href="https://beian.miit.gov.cn/" target="_blank">京ICP证{{icpCode}}号</a>
        </div>
    `,
    initData() {
        return {
            networkSecurityCode: ICP_CONF.network_security_code,
            icpCode: ICP_CONF.icp_code,
        };
    },
});

export default Footer;
